import _throttle from 'lodash/throttle';
import { defaultValue } from 'Components/dialogs/Preferences/components/FullScreen.form';
import { isHexColor } from '@/utils/validator';

const viewModeSinglePage = 'single-page-view-mode';
// const modeShouldTurn = ['continuous-view-mode', 'facing-continuous-page-view-mode'];

export default class FullScreenController {
  constructor() {
    this.isFullscreen = false;
    this.fullScreen = null;
    this.interval = null;
    this.hasAddViewModeListener = false;
    this.viewModeNormal = null;
    this.viewModeFullScreen = null;
    this.viewer = null;
    this.normalScale = 1.0;
    this.shortcuts = [];
    this.mount = this.mount.bind(this);
    this.getScale = this.getScale.bind(this);
    this.clearAutoPlay = this.clearAutoPlay.bind(this);
    this.continueAutoPlay = this.continueAutoPlay.bind(this);
    this.toggleHeader = this.toggleHeader.bind(this);
    this.toggleNavigation = this.toggleNavigation.bind(this);
    this.toggleShowWholePage = this.toggleShowWholePage.bind(this);
    this.toggleScrollWidth = this.toggleScrollWidth.bind(this);
    this.toggleStatusBar = this.toggleStatusBar.bind(this);
    this.toggleBackgroundColor = this.toggleBackgroundColor.bind(this);
    this.toggleExitButton = this.toggleExitButton.bind(this);
    this.toggleMouseClickListener = this.toggleMouseClickListener.bind(this);
    this.toggleAutoFlip = this.toggleAutoFlip.bind(this);
    this.toggleKeyboardListener = this.toggleKeyboardListener.bind(this);
    this.showFullScreenMode = this.showFullScreenMode.bind(this);
    this.notifyExplorer = this.notifyExplorer.bind(this);
    this.renderSVG = this.renderSVG.bind(this);
    this.containerClickListener = this.containerClickListener.bind(this);
    this.exitButtonClickListener = this.exitButtonClickListener.bind(this);
    this.handlePageNext = _throttle(this.turnPageNext, 500, { leading: true });
    this.handlePagePrev = _throttle(this.turnPagePrev, 500, { leading: true });
    this.couldTurnToPageStart = this.couldTurnToPageStart.bind(this);
    this.couldTurnToPageEnd = this.couldTurnToPageEnd.bind(this);
    this.docPrevListener = this.docPrevListener.bind(this);
    this.docNextListener = this.docNextListener.bind(this);
    this.count = this.count.bind(this);
  }

  mount() {
    if (this.hasAddViewModeListener) return;
    this.hasAddViewModeListener = true;
    const Events = UIExtension.PDFViewCtrl.Events;
    this.shortcuts = [
      ['UpArrow', this.docPrevListener],
      ['PageUp', this.docPrevListener],
      ['Home', this.docPrevListener],
      ['UpArrow', this.docPrevListener],
      ['DownArrow', this.docNextListener],
      ['PageDown', this.docNextListener],
      ['End', this.docNextListener],
    ];
    pdfui.addViewerEventListener(Events.changeViewModeSuccess, () => {
      const isFullscreen = this.isFullscreen;
      const viewModeManager = pdfui.pdfViewer.getViewModeManager();
      const name = viewModeManager.currentViewMode.getName();
      if (isFullscreen) {
        this.viewModeFullScreen = name;
      } else {
        this.viewModeNormal = name;
        this.viewModeFullScreen = name;
      }
    })
  }

  async getScale() {
    const docRender = await pdfui.getPDFDocRender();
    
    return docRender.getScale()
  }

  notifyExplorer() {
    pdfui.eventEmitter.emit('fullscreenchange', this.isFullscreen);
    const doc = window.document;
    const docEl = doc.documentElement;
    const requestFullScreen = docEl.requestFullscreen || docEl.mozRequestFullScreen || docEl.webkitRequestFullScreen || docEl.msRequestFullscreen;
    const cancelFullScreen = doc.exitFullscreen || doc.mozCancelFullScreen || doc.webkitExitFullscreen || doc.msExitFullscreen;
    if (!doc.fullscreenElement && !doc.mozFullScreenElement && !doc.webkitFullscreenElement && !doc.msFullscreenElement) {
      requestFullScreen && requestFullScreen.call(docEl);
    } else {
      cancelFullScreen && cancelFullScreen.call(doc);
    }
  }

  async docPrevListener(e) {
    if (e.nativeEvent.target instanceof HTMLInputElement) {
      return;
    }
    if (this.isFullscreen) {
      // const shouldTurnToPageEnd = await this.couldTurnToPageEnd();
      this.handlePagePrev();
      // if (modeShouldTurn.includes(this.viewModeFullScreen)) {
      // } else if (shouldTurnToPageEnd) {
      //   const pdfDoc = await pdfui.getCurrentPDFDoc();
      //   const docRender = await pdfui.getPDFDocRender();
      //   const pageCount = pdfDoc.getPageCount();
      //   docRender.goToPage(pageCount - 1);
      // }
    }
  }

  async docNextListener(e) {
    if (e.nativeEvent.target instanceof HTMLInputElement) {
      return;
    }
    // const shouldTurnToPageStart = await this.couldTurnToPageStart();
    if (this.isFullscreen) {
      this.handlePageNext();
      // if (modeShouldTurn.includes(this.viewModeFullScreen)) {
      // } else if (shouldTurnToPageStart) {
      //   const docRender = await pdfui.getPDFDocRender();
      //   docRender.goToPage(0);
      // }
    }
  }

  async getPageIndex() {
    const docRender = await pdfui.getPDFDocRender();
    const currentPageIndex = docRender.getCurrentPageIndex();
    return currentPageIndex;
  }

  count() {
    if (isNaN(this.countNum)) {
      this.countNum = 0;
    } else {
      this.countNum++;
    }
    console.log(`count: ${this.countNum}`)
  }

  async turnPagePrev() {
    const pdfDoc = await pdfui.getCurrentPDFDoc();
    const docRender = await pdfui.getPDFDocRender();
    const pageCount = pdfDoc.getPageCount();
    // this.count();
    if (this.isFullscreen) {
      const shouldTurnToPageEnd = await this.couldTurnToPageEnd();
      if (shouldTurnToPageEnd) {
        docRender.goToPage(pageCount - 1);
      } else {
        docRender.prevPage();
      }
    }
  }

  async turnPageNext() {
    const docRender = await pdfui.getPDFDocRender();
    // this.count();
    if (this.isFullscreen) {
      const shouldTurnToPageStart = await this.couldTurnToPageStart();
      if (shouldTurnToPageStart) {
        docRender.goToPage(0);
      } else {
        docRender.nextPage();
      }
    }
  }

  async couldTurnToPageEnd() {
    const { loopScroll } = this.fullScreen;
    const currentPageIndex = await this.getPageIndex();
    return loopScroll && currentPageIndex === 0;
  }

  async couldTurnToPageStart() {
    const { loopScroll } = this.fullScreen;
    const pdfDoc = await pdfui.getCurrentPDFDoc();
    const pageCount = pdfDoc.getPageCount();
    const currentPageIndex = await this.getPageIndex();
    return loopScroll && currentPageIndex === pageCount - 1;
  }

  toggleHeader() {
    const header = document.querySelector('.header_container');
    const toolbar = document.querySelector('.fv__ui-toolbar');
    if (this.isFullscreen) {
      header.addClass('fv__hidden');
      toolbar.addClass('fv__hidden');
    } else {
      header.removeClass('fv__hidden');
      toolbar.removeClass('fv__hidden');
    }
  }

  toggleNavigation() {
    const { showNavigationPanels } = this.fullScreen;
    const navigationPanel = document.querySelector('.fv__ui-sidebar');
    if (this.isFullscreen) {
      if (!showNavigationPanels) {
        navigationPanel.addClass('fv__hidden');
      } else {
        navigationPanel.removeClass('fv__hidden');
      }
    } else {
      navigationPanel.removeClass('fv__hidden');
    }
  }

  toggleScrollWidth() {
    const { showScrollBar } = this.fullScreen;
    const scrollArea = document.querySelector('.fv__ui-pdfviewer');
    if (this.isFullscreen) {
      if (showScrollBar) {
        scrollArea.removeClass('scroll-hide');
      } else {
        scrollArea.addClass('scroll-hide');
      }
    } else {
      scrollArea.removeClass('scroll-hide');
    }
  }

  async toggleShowWholePage() {
    const viewer = this.viewer;
    const { showTheWholePage } = this.fullScreen;
    const viewModeManager = pdfui.pdfViewer.getViewModeManager();
    if (this.isFullscreen && showTheWholePage) {
      const stateHandlerManager = pdfui.pdfViewer.stateHandlerManager;
      this.normalScale = await this.getScale();
      this.viewer.zoomTo('fitHeight'); // need fit page height totally
      stateHandlerManager.switchTo('hand'); // need to hand view mode
      this.viewModeNormal = viewModeManager.currentViewMode.getName();
      viewModeManager.switchTo(viewModeSinglePage);
    } else {
      viewer.zoomTo(this.normalScale); // need reset to fit width
      viewModeManager.switchTo(this.viewModeNormal);
    }
  }

  // status bar is the float bar in code
  toggleStatusBar() {
    const { showStatusBar } = this.fullScreen;
    const statusBar = document.querySelector('.float-bar');
    if (this.isFullscreen) {
      if (showStatusBar) {
        statusBar.removeClass('fv__hidden');
      } else {
        statusBar.addClass('fv__hidden');
      }
    } else {
      statusBar.removeClass('fv__hidden');
    }
  }

  toggleBackgroundColor() {
    const { color: backgroundColor } = this.fullScreen;
    const defaultBgColor = '#dddedf';
    const scrollArea = document.querySelector('.fv__ui-pdfviewer');
    if (this.isFullscreen) {
      scrollArea.style.background = backgroundColor;
    } else {
      scrollArea.style.background = defaultBgColor;
    }
  }

  renderSVG(color) {
    // FIX ONLINERD-10269, Audit XSS:DOM
    if (!isHexColor(color)) {
      color = '#923094';
    }
    return (
      `<svg width="24" height="24" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path class="button-color-fill" d="M0 1C0 0.447715 0.447715 0 1 0H15C15.5523 0 16 0.447715 16 1V15C16 15.5523 15.5523 16 15 16H1C0.447715 16 0 15.5523 0 15V1Z" fill="${color}"/>
        <path d="M2.06062 14.5962L5.59615 11.0607C5.79142 10.8654 5.79142 10.5489 5.59615 10.3536C5.40089 10.1583 5.08431 10.1583 4.88905 10.3536L1.35351 13.8891C1.15825 14.0844 1.15825 14.401 1.35351 14.5962C1.54878 14.7915 1.86536 14.7915 2.06062 14.5962Z" fill="white"/>
        <path d="M5.94971 13.5001V10.5001C5.94971 10.224 5.72585 10.0001 5.44971 10.0001C5.17356 10.0001 4.94971 10.224 4.94971 10.5001V13.5001C4.94971 13.7763 5.17356 14.0001 5.44971 14.0001C5.72585 14.0001 5.94971 13.7763 5.94971 13.5001Z" fill="white"/>
        <path d="M2.44971 11.0001H5.44971C5.72585 11.0001 5.94971 10.7763 5.94971 10.5001C5.94971 10.224 5.72585 10.0001 5.44971 10.0001H2.44971C2.17356 10.0001 1.94971 10.224 1.94971 10.5001C1.94971 10.7763 2.17356 11.0001 2.44971 11.0001Z" fill="white"/>
        <path d="M14.5955 13.8884L11.0607 10.3536C10.8654 10.1583 10.5489 10.1583 10.3536 10.3536C10.1583 10.5488 10.1583 10.8654 10.3536 11.0607L13.8884 14.5955C14.0837 14.7907 14.4003 14.7907 14.5955 14.5955C14.7908 14.4002 14.7908 14.0836 14.5955 13.8884Z" fill="white"/>
        <path d="M11.0002 13.5V10.5C11.0002 10.2239 10.7764 10 10.5002 10C10.2241 10 10.0002 10.2239 10.0002 10.5V13.5C10.0002 13.7761 10.2241 14 10.5002 14C10.7764 14 11.0002 13.7761 11.0002 13.5Z" fill="white"/>
        <path d="M13.4992 10H10.5002C10.2241 10 10.0002 10.2239 10.0002 10.5C10.0002 10.7761 10.2241 11 10.5002 11H13.4992C13.7754 11 13.9992 10.7761 13.9992 10.5C13.9992 10.2239 13.7754 10 13.4992 10Z" fill="white"/>
        <path d="M1.35359 2.06062L4.88912 5.59615C5.08438 5.79142 5.40097 5.79142 5.59623 5.59615C5.79149 5.40089 5.79149 5.08431 5.59623 4.88905L2.0607 1.35351C1.86543 1.15825 1.54885 1.15825 1.35359 1.35351C1.15833 1.54878 1.15833 1.86536 1.35359 2.06062Z" fill="white"/>
        <path d="M4.94971 2.44971V5.44971C4.94971 5.72585 5.17356 5.94971 5.44971 5.94971C5.72585 5.94971 5.94971 5.72585 5.94971 5.44971V2.44971C5.94971 2.17356 5.72585 1.94971 5.44971 1.94971C5.17356 1.94971 4.94971 2.17356 4.94971 2.44971Z" fill="white"/>
        <path d="M2.44971 5.94971H5.44971C5.72585 5.94971 5.94971 5.72585 5.94971 5.44971C5.94971 5.17356 5.72585 4.94971 5.44971 4.94971H2.44971C2.17356 4.94971 1.94971 5.17356 1.94971 5.44971C1.94971 5.72585 2.17356 5.94971 2.44971 5.94971Z" fill="white"/>
        <path d="M13.8894 1.35356L10.3545 4.88839C10.1593 5.08365 10.1593 5.40023 10.3545 5.5955C10.5498 5.79076 10.8664 5.79076 11.0616 5.5955L14.5965 2.06067C14.7917 1.86541 14.7917 1.54883 14.5965 1.35356C14.4012 1.1583 14.0846 1.1583 13.8894 1.35356Z" fill="white"/>
        <path d="M10 2.44997V5.44897C10 5.72512 10.2239 5.94897 10.5 5.94897C10.7761 5.94897 11 5.72512 11 5.44897V2.44997C11 2.17383 10.7761 1.94997 10.5 1.94997C10.2239 1.94997 10 2.17383 10 2.44997Z" fill="white"/>
        <path d="M13.5 4.94897H10.501C10.2248 4.94897 10.001 5.17283 10.001 5.44897C10.001 5.72512 10.2248 5.94897 10.501 5.94897H13.5C13.7761 5.94897 14 5.72512 14 5.44897C14 5.17283 13.7761 4.94897 13.5 4.94897Z" fill="white"/>
      </svg>`);
  }

  toggleExitButton() {
    const { showExitButton, color } = this.fullScreen;
    if (document.querySelector('.exit-full-screen')) {
      document.querySelector('.exit-full-screen').remove();
    }
    if (document.querySelector('.exit-full-screen') === null) {
      const scrollArea = document.querySelector('.fv__ui-pdfviewer');
      const $div = document.createElement('div');
      $div.addClass('exit-full-screen');
      $div.removeEventListener('click', this.exitButtonClickListener);
      $div.addEventListener('click', this.exitButtonClickListener, false);
      $div.innerHTML = this.renderSVG(color);
      scrollArea.insertBefore($div, document.querySelector('.fv__pdf-viewer'));
    }
    if (this.isFullscreen) {
      if (showExitButton) {
        const $exitButton = document.querySelector('.exit-full-screen');
        $exitButton.style.display = 'block';
      } else {
        const $exitButton = document.querySelector('.exit-full-screen');
        $exitButton.style.display = 'none';
      }
    } else {
      const $exitButton = document.querySelector('.exit-full-screen');
      $exitButton.style.display = 'none';
    }
  }

  containerClickListener(e) {
    const { classList = [] } = e.target;
    const classArrary = [
      // 页面过渡添加的
      'custom-page', 
      'custom-page-item',
      'custom-page-item velocity-animating',
      'fv__hand-state-contextmenu-container custom-page',
      // 之前的
      'fv__hand-state-contextmenu-container fv__contextmenu-container',
    ];
    if (!classArrary.includes(classList.value)) return;
    const { fullScreen = defaultValue } = JSON.parse(localStorage.getItem('formPreference') || '{}');
    const { mouseClickToScroll } = fullScreen;
    if (!mouseClickToScroll || !this.isFullscreen) return;
    this.continueAutoPlay();
    switch (e.button) {
      case 0:
        this.handlePageNext();
        break;
      case 2:
        this.handlePagePrev();
        break;
      default:
        break;
    }
  }

  exitButtonClickListener() {
    this.viewer.customs.setFullScreen({ isFullscreen: false, callExplorer: true });
  }

  toggleMouseClickListener() {
    const { fullScreen = defaultValue } = JSON.parse(localStorage.getItem('formPreference') || '{}');
    const { mouseClickToScroll } = fullScreen;
    const $container = document.querySelector('.fv__ui-pdfviewer');
    $container.removeEventListener('mousedown', this.containerClickListener);
    if (this.isFullscreen && mouseClickToScroll) {
      $container.addEventListener('mousedown', this.containerClickListener, false);
    }
  }

  clearAutoPlay() {
    const intD = this.interval;
    if (intD !== null) {
      clearInterval(intD);
      this.interval = null;
    }
  }

  continueAutoPlay() {
    this.clearAutoPlay();
    const { fullScreen = defaultValue } = JSON.parse(localStorage.getItem('formPreference') || '{}');
    const { autoFlip: { shouldAutoFlip, seconds } } = fullScreen;
    if (shouldAutoFlip) {
      this.interval = setInterval(() => {
        this.handlePageNext();
      }, parseInt(seconds, 10) * 1000);
    } else {
      this.clearAutoPlay();
    }
  }

  toggleAutoFlip() {
    if (this.isFullscreen) {
      this.continueAutoPlay();
    } else {
      this.clearAutoPlay();
    }
  }

  toggleKeyboardListener() {
    if (this.isFullscreen) {
      this.shortcuts.forEach(shortcut => {
        pdfui.pdfViewer.onShortcutKey(...shortcut);
      });
    } else {
      this.shortcuts.forEach(shortcut => {
        pdfui.pdfViewer.offShortcutKey(...shortcut);
      });
    }
  }
  toggleLeftPanel(){
    pdfui.getComponentByName('sidebar-right')
    .then(component=>{
      component.isVisible?component.hide():component.show();
    })
  }
  async showFullScreenMode({ isFullscreen = true, callExplorer = false }) {
    const { fullScreen = defaultValue } = JSON.parse(localStorage.getItem('formPreference') || '{}');
    const viewer = await pdfui.getPDFViewer();
    this.viewer = viewer;
    const { eventEmitter } = viewer;
    this.isFullscreen = isFullscreen;
    this.fullScreen = fullScreen;
    eventEmitter.emit('fullscreen-trigger', { isFullscreen, ...fullScreen });
    if (isFullscreen) {
      const stateHandlerManager = pdfui.pdfViewer.stateHandlerManager;
      stateHandlerManager.switchTo('hand'); // need to hand view mode
    }
    await this.mount();
    this.toggleHeader();
    this.toggleNavigation();
    this.toggleScrollWidth();
    this.toggleStatusBar();
    this.toggleBackgroundColor();
    this.toggleExitButton();
    this.toggleShowWholePage();
    this.toggleMouseClickListener();
    this.toggleAutoFlip();
    this.toggleKeyboardListener();
    this.toggleLeftPanel();
    if (callExplorer) {
      this.notifyExplorer();
    }
  }
}
